import { render, staticRenderFns } from "./AdminWhitelistDelete.vue?vue&type=template&id=5393bdba&scoped=true"
import script from "./AdminWhitelistDelete.vue?vue&type=script&lang=js"
export * from "./AdminWhitelistDelete.vue?vue&type=script&lang=js"
import style0 from "./AdminWhitelistDelete.vue?vue&type=style&index=0&id=5393bdba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5393bdba",
  null
  
)

export default component.exports